export default {"src":"/_next/static/media/line-through-file.69670d24.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};